import { render, staticRenderFns } from "./MiniEventSlide.vue?vue&type=template&id=c94828b6&scoped=true&"
import script from "./MiniEventSlide.vue?vue&type=script&lang=ts&"
export * from "./MiniEventSlide.vue?vue&type=script&lang=ts&"
import style0 from "./MiniEventSlide.vue?vue&type=style&index=0&id=c94828b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94828b6",
  null
  
)

export default component.exports